import Image from 'next/image'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import { assetUrl } from 'utils/url'

interface CardEvaluasiKinerjaTahunanProps {
  year: number
}

export default function CardEvaluasiKinerjaTahunan({
  year,
}: CardEvaluasiKinerjaTahunanProps) {
  const { trackEvent } = useSKPPelaksanaanTrackEvent()
  const isPriorTo2025 = year < 2025

  const resultUrl = `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-evaluasi-kinerja-pegawai${
    isPriorTo2025 ? '?annual=true' : ''
  }`

  return (
    <Card className="p-6 !bg-gradient-to-r from-blue-90 to-blue-80 overflow-hidden">
      <img
        alt=""
        role="presentation"
        src={assetUrl('/images/pengelolaan-kinerja/confetti.png')}
        className="absolute right-0 top-0 z-0"
        height={60}
        width={144}
      />
      <div className="flex gap-6 items-center">
        <div className="flex-shrink-0">
          <Image
            alt=""
            src="/illustrations/img-reflection-documents-magnifying-glass.png"
            width={84}
            height={84}
          />
        </div>
        <div className="flex-1 flex flex-col gap-1 justify-center items-start">
          <div className="flex flex-col items-start gap-2">
            <Text variant="subheading" className="!uppercase" color="inverse">
              Hasil Penilaian Kinerja
            </Text>
            <Text variant="heading-lg" color="inverse">
              Predikat Kinerja Tahun {year}
            </Text>
          </div>
        </div>
        <div className="w-60 z-10">
          <Link href={resultUrl} passHref>
            <Button
              size="lg"
              as="a"
              color="white"
              fullWidth
              onClick={() =>
                trackEvent({
                  activity_type: 'click_cek_dokumen_evaluasi',
                  screen_name: 'homepage_pengelolaan',
                })
              }
            >
              <Text className="!text-interactive-default" variant="action">
                Cek
              </Text>
            </Button>
          </Link>
        </div>
      </div>
    </Card>
  )
}
